import * as React from 'react'
import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { FormSection } from '@sales-center/components'
import { ILeadFormModel } from '../../typings'
import {
  addLeadPreferredMethodOfContact,
  addLeadPreferredTimeOfContact,
} from '@user/components/Settings/EntityFormSettings'
import type { FieldSettingsMap } from '@user/store/entityFormSettings'
import Grid from '@mui/material/Grid'
import { TextFieldProps } from '@mui/material/TextField'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { BestContactMethodSelect } from '@user/components/Formik/BestContactMethodSelect/BestContactMethodSelect'
import { BestContactTimeSelect } from '@user/components/Formik/BestContactTimeSelect/BestContactTimeSelect'

const bestContactMethods = [
  { label: 'Phone', value: 'Phone' },
  { label: 'Email', value: 'Email' },
  { label: 'SMS', value: 'SMS' },
]

const bestContactTimes = [
  { label: 'Morning', value: 'morning' },
  { label: 'Afternoon', value: 'afternoon' },
  { label: 'Evening', value: 'evening' },
  { label: 'Weekend', value: 'weekend' },
]

interface Props {
  hideOptional: boolean
  disabled?: boolean
  settingsMap: FieldSettingsMap
  textFieldProps?: TextFieldProps
  spacing?: number
}

export function FollowUpInformation(props: Props) {
  const { settingsMap, spacing = 2 } = props
  const tidalThemeActive = useTidalThemeActive()

  const {
    setFieldValue,
    values: { preferredTimeOfContact, preferredMethodOfContact },
  } = useFormikContext<ILeadFormModel>()

  const [requiredPreferredMethodOfContact, showPreferredMethodOfContact] =
    settingsMap.get(addLeadPreferredMethodOfContact) ?? [false, true]
  const [requiredPreferredTimeOfContact, showPreferredTimeOfContact] =
    settingsMap.get(addLeadPreferredTimeOfContact) ?? [false, true]

  useEffect(() => {
    if (
      !preferredMethodOfContact &&
      requiredPreferredMethodOfContact &&
      showPreferredMethodOfContact &&
      bestContactMethods?.length == 1
    ) {
      setFieldValue(
        addLeadPreferredMethodOfContact,
        bestContactMethods[0]?.value,
      )
    }
  }, [
    preferredMethodOfContact,
    requiredPreferredMethodOfContact,
    showPreferredMethodOfContact,
  ])

  useEffect(() => {
    if (
      preferredTimeOfContact?.length == 0 &&
      requiredPreferredTimeOfContact &&
      showPreferredTimeOfContact &&
      bestContactTimes?.length == 1
    ) {
      setFieldValue(addLeadPreferredTimeOfContact, [bestContactTimes[0]?.value])
    }
  }, [
    preferredTimeOfContact,
    requiredPreferredTimeOfContact,
    showPreferredTimeOfContact,
  ])

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  return (
    <FormSection
      label="Follow Up Information"
      spacing={spacing}
      paddingBottom={4}
      maxWidth="660px"
    >
      <Grid item xs={12}>
        <Grid item xs={12} mb={2}>
          <BestContactMethodSelect
            density={density}
            name={addLeadPreferredMethodOfContact}
            required={requiredPreferredMethodOfContact}
            show={showPreferredMethodOfContact}
          />
        </Grid>
        <BestContactTimeSelect
          density={density}
          name={addLeadPreferredTimeOfContact}
          required={requiredPreferredTimeOfContact}
          show={showPreferredTimeOfContact}
          showCheckBox
        />
      </Grid>
    </FormSection>
  )
}
